
import React, { useEffect } from 'react';
import { pageRouteConstants } from '../../constants/constants';
import { useNavigate } from 'react-router';

const PdfPopup = () => {

  const navigate = useNavigate();
  useEffect(() => {
    const pdfPath = '/Demo_document_for_User_Management_Service_2.0.docx.pdf';
    window.open(`/pdf-viewer.html?file=${pdfPath}`, '_blank');
  }, []);
  navigate(pageRouteConstants.dashBoardRoute);
  return null;
};

export default PdfPopup;
